/**
 * SA global-settings API client (P1, 2026-06-15).
 *
 * Typed wrappers around the `/admin/platform-settings` endpoints. The Unavatar
 * PRO token is a SECRET: the server NEVER returns it. `unavatar_token` here is
 * the masked display (`"••••" + last4`) or `null` when unset — there is no way
 * to read the plaintext back.
 */
import { apiClient } from "@/lib/apiClient";

export interface PlatformSettings {
  /** Masked display (`"••••1234"`) or null when no token is set. Never plaintext. */
  unavatar_token: string | null;
  unavatar_token_set_at: string | null;
  unavatar_token_set_by: string | null;
}

export async function fetchPlatformSettings(): Promise<PlatformSettings> {
  const r = await apiClient.get<PlatformSettings>("/admin/platform-settings");
  return r.data;
}

export async function setUnavatarToken(token: string): Promise<PlatformSettings> {
  const r = await apiClient.put<PlatformSettings>(
    "/admin/platform-settings/unavatar-token",
    { token }
  );
  return r.data;
}

export async function clearUnavatarToken(): Promise<PlatformSettings> {
  const r = await apiClient.delete<PlatformSettings>(
    "/admin/platform-settings/unavatar-token"
  );
  return r.data;
}
